import Common from '../../Common';

const Favorite = class extends Common {
	update = (contactId: id, body: { pbx_contact_favorite: number }) =>
		this.patch(`/contact/${contactId}/favorite`, body)

	create = (contactId: id) =>
		this.post(`/contact/${contactId}/favorite`, { pbx_contact_favorite: 1 })

	delete = (contactId: id) =>
		this.doDelete(`/contact/${contactId}/favorite
	`)
}

export default Favorite
